import React from 'react';

const RecoveryAnalysis = ({ data }) => {
  if (!data) return null;

  const { decision, nextHardSession, strategy, priorities } = data;

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
        <h3 className="text-gray-400 text-xs uppercase tracking-wider mb-4">Recovery & Strategy</h3>
        
        {/* Next Hard Session Warning */}
        {nextHardSession && (
            <div className="mb-6 p-4 rounded-lg bg-gray-900/50 border border-gray-700">
                <p className="text-xs text-orange-400 uppercase tracking-wide mb-1">Target Session In</p>
                <div className="flex items-baseline gap-2">
                    <span className="text-2xl font-bold text-white">{nextHardSession.daysUntil} Days</span>
                    <span className="text-sm text-gray-500">({nextHardSession.dayName})</span>
                </div>
                <p className="text-sm text-gray-400 mt-1">{nextHardSession.type}</p>
            </div>
        )}

        {/* Coach's Strategy */}
        <div className="mb-6">
            <p className="text-sm text-gray-300 italic border-l-2 border-blue-500 pl-3 py-1">
                "{strategy || "Focus on consistency and feeling good."}"
            </p>
        </div>

        {/* Top 3 Priorities */}
        <div>
             <h4 className="text-sm font-semibold text-gray-200 mb-3">Top Priorities</h4>
             <div className="space-y-2">
                 {priorities && priorities.map((p, idx) => (
                     <div key={idx} className="flex items-center gap-3 bg-gray-700/20 p-2 rounded hover:bg-gray-700/40 transition">
                         <span className="text-xl">{p.emoji}</span>
                         <div>
                             <p className="text-sm font-medium text-blue-200">{p.area}</p>
                             <p className="text-xs text-gray-400">{p.action}</p>
                         </div>
                     </div>
                 ))}
             </div>
        </div>
    </div>
  );
};

export default RecoveryAnalysis;
